import { createContext } from "react"
export const MidiaContext = createContext()
MidiaContext.displayName = "MidiaContext"
